import { Select, SelectProps } from 'components'
import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'

export interface Props<V extends string, M extends boolean = false>
  extends ScaleProps<SelectProps<V, M>> {}

export default function SDropdown<V extends string, M extends boolean = false>(props: Props<V, M>) {
  const { styleProps, rest } = useScaleProps(props)
  return <Select {...styleProps} {...rest} />
}
